export const API_KEY = "468d413c44d12876b4f3a40147ab3946";
export const firebaseConfig = {
  apiKey: "AIzaSyAFeKAKqEln5tet46tcwxcFD51-EJ06_vs",
  authDomain: "rmdb-b52e8.firebaseapp.com",
  databaseURL: "https://rmdb-b52e8.firebaseio.com",
  projectId: "rmdb-b52e8",
  storageBucket: "rmdb-b52e8.appspot.com",
  messagingSenderId: "956358224364",
  appId: "1:956358224364:web:c0793a3f440b9a39"
};
